import api from "./api";

// ── Users ────────────────────────────────────────────────────
export function getUsers(params = {}) {
  return api.get("/admin/users", { params });
}

export function getUser(userId) {
  return api.get(`/admin/users/${userId}`);
}

export function updateUser(userId, payload) {
  return api.put(`/admin/users/${userId}`, payload);
}

export function deleteUser(userId) {
  return api.delete(`/admin/users/${userId}`);
}

// ── Subscriptions ────────────────────────────────────────────
export function getSubscriptions(params = {}) {
  return api.get("/admin/subscriptions", { params });
}

export function cancelSubscription(subscriptionId) {
  return api.post(`/admin/subscriptions/${subscriptionId}/cancel`);
}

// ── Dashboard / Stats ────────────────────────────────────────
export function getDashboardStats() {
  return api.get("/admin/stats");
}

// ── Settings ─────────────────────────────────────────────────
export function getSettings() {
  return api.get("/admin/settings");
}

export function updateSettings(payload) {
  return api.put("/admin/settings", payload);
}